import dashboard from './user/dashboard'
import watches from './user/watches'
import alerts from './user/alerts'
import myidicare from './user/myidicare'

export default [
	...myidicare,
	...dashboard,
	...watches,
	...alerts
]



// WEBPACK FOOTER //
// ./src/router/modules/user.js